import { createReducer } from '@reduxjs/toolkit'

import { arrayToObject } from 'helpers/Functions'

import { GlobalCredentialsGroup } from 'types/GlobalCredentials'

import * as actions from '../../actions/CredentialsGroups/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface CredentialsGroupsBody {
  [key: string]: GlobalCredentialsGroup
}

export interface CredentialsGroupsReducerType {
  data: CredentialsGroupsBody
  fetched: boolean
}

const INITIAL_STATE: CredentialsGroupsReducerType = {
  data: {},
  fetched: false
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = arrayToObject(action.payload.data) as CredentialsGroupsBody
      state.fetched = true
    })
    .addCase(actions.createSuccess, (state, action) => {
      state.data[action.payload.data.id] = action.payload.data
    })
    .addCase(actions.destroySuccess, (state, action) => {
      delete state.data[action.payload]
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
